// BOXEB2B — AdSlot: reusable Google AdSense placement.
//
// Renders a discreet "Sponsored" ad unit. Auto-hides itself if AdSense fails to fill
// within 4 seconds (prevents empty gray boxes that hurt UX).
//
// Publisher: ca-pub-7207598762386087
// Slot IDs are placeholders — user must create ad units in their AdSense dashboard
// and paste the numeric slot IDs (`data-ad-slot`) here.
import React, { useEffect, useRef, useState } from "react";

const PUBLISHER_ID = "ca-pub-7207598762386087";

export default function AdSlot({
    slot = "0000000000",             // AdSense ad unit slot id
    format = "auto",                 // "auto" | "fluid" | "rectangle" | "horizontal" | "vertical"
    layout,                          // optional layout key for in-article
    className = "",
    label = "Sponsorisé",
    testId,
}) {
    const insRef = useRef(null);
    const [hidden, setHidden] = useState(false);

    useEffect(() => {
        // Only try to load if AdSense global is present (script tag in index.html).
        if (typeof window === "undefined" || !window.adsbygoogle) return;
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (_e) { /* AdSense not ready — ignore */ }

        // Auto-hide if unfilled after 4s (avoids "empty ad" gray boxes).
        const timer = setTimeout(() => {
            if (insRef.current) {
                const filled = insRef.current.getAttribute("data-ad-status") === "filled";
                if (!filled) setHidden(true);
            }
        }, 4000);
        return () => clearTimeout(timer);
    }, []);

    if (hidden) return null;

    return (
        <div className={`w-full my-8 ${className}`} data-testid={testId || "ad-slot"}>
            <div className="text-[10px] uppercase tracking-widest text-zinc-600 mb-1.5 font-mono">{label}</div>
            <ins
                ref={insRef}
                className="adsbygoogle block"
                style={{ display: "block", minHeight: 90 }}
                data-ad-client={PUBLISHER_ID}
                data-ad-slot={slot}
                data-ad-format={format}
                data-full-width-responsive="true"
                {...(layout ? { "data-ad-layout": layout } : {})}
            />
        </div>
    );
}
